/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AssegnazioneArticoloCedolaCreationForm { 
    titolo: string;
    editore?: string;
    area?: string;
    volume?: string;
    note?: string;
    valore: number;
    attivo?: boolean;
}

